// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"saveSearch_wrapper__9oMrn","errorMessage":"saveSearch_errorMessage__JgRBl","textBoxWrp":"saveSearch_textBoxWrp__1p4l7"};